import DaysOfWeekTable from './DaysOfWeekTable';

export default DaysOfWeekTable;
